import { render, staticRenderFns } from "./CollapseListItem.vue?vue&type=template&id=4adad913"
import script from "./CollapseListItem.vue?vue&type=script&lang=js"
export * from "./CollapseListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports